<button (click)="openAddContactForm()" *ngIf="!isEdit" class="invited-chip" mat-raised-button>
	Add Contact
</button>

<mat-icon (click)="openAddContactForm()" *ngIf="isEdit" class="cursor-pointer">
	edit
</mat-icon>
